module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/equipment04_sp-c1f8358626e7f3a5f49d5cde7e673e81.png";